import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService } from './Toast.service';
import * as $ from 'jquery';
@Component({
  selector: 'app-Toast',
  templateUrl: './Toast.component.html'
})
export class ToastComponent implements OnInit {
  toast_Subscription: Subscription; timer;
  constructor(private PNS: ToastService) { }
show=false;msg="";toast_type=0;show_close=false;
  ngOnInit() {
    this.toast_Subscription = this.PNS.toast_init.subscribe((value) => {
      console.log(value);
      this.show=false;
      if(value.show){
        this.msg=value.msg;this.toast_type=value.toast_type;this.show_close=value.show_close;
          if(value.autohide){

            clearTimeout(this.timer);
            this.timer= setTimeout(() => {
              this.close();
            }, 3500);
          }
          this.show=true; 
          setTimeout(() => {
            //$("#ptoast_msg").fadeIn('slow').animate({ opacity: 0 }, 0);

            $("#ptoast_msg").fadeIn({queue: false, duration: 'slow'});
           // $("#ptoast_msg").animate({ top: "-10px" }, 'slow');


          });
         
      }
    });
  }
  

  close(){
    //var parent = $("#ptoast_msg").parent('.toast');
    $("#ptoast_msg").fadeOut("slow", ()=> {  this.show=false; } );
   
  }
 
  ngOnDestroy() {
  this. _unsubscribe()
  }

  _unsubscribe(){
    this.toast_Subscription.unsubscribe();
  }
}
